(function () {
    'use strict';

    angular.module('blocks.formly', [
        'formly',
        'formlyBootstrap',
        'ui.bootstrap',
        'ui.select',
        'blocks.logger'
    ]);
})();
